import { useAlertConfig } from '../../../../ui/hooks';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { useNotifyClient } from '@juvare/platform-sdk-react/ui/hooks';
import React, { useCallback } from 'react';
import { InboxClient } from '../clients';
export function useInboxClient() {
    var _a, _b;
    const alertConfig = useAlertConfig();
    const userState = useUserState();
    const notifyClient = useNotifyClient();
    const onInboxTokenRequest = useCallback(() => notifyClient.getInboxToken().then((response) => response.token), [notifyClient]);
    const loginEmail = (_b = (_a = alertConfig.loginEmail) === null || _a === void 0 ? void 0 : _a.call(alertConfig, userState)) !== null && _b !== void 0 ? _b : userState.email;
    return React.useMemo(() => new InboxClient(loginEmail, onInboxTokenRequest), [onInboxTokenRequest, loginEmail]);
}
